import Axios from "../config/axios-v1-config";

export const getAllProspects = async () => {
  const response = await Axios.get("prospects/get-all-prospects").catch((err) => {
    return { error: err.response?.data || { message: err.message } };
  });

  return response;
};

export const createProspect = async ({ values }) => {
  const response = await Axios.post("prospects/create-prospect", { ...values }).catch((err) => {
    return { error: err.response?.data || { message: err.message } };
  });

  return response;
};

export const updateProspect = async ({ id, values }) => {
  const response = await Axios.patch(`prospects/${id}`, { ...values }).catch((err) => {
    return { error: err.response?.data || { message: err.message } };
  });

  return response;
};

export const deleteProspect = async ({ id }) => {
  const response = await Axios.delete(`prospects/${id}`).catch((err) => {
    return { error: err.response?.data || { message: err.message } };
  });

  return response;
};
